import { render, staticRenderFns } from "./BaseFormCheckboxFieldWithValidator.vue?vue&type=template&id=638c13d8"
import script from "./BaseFormCheckboxFieldWithValidator.vue?vue&type=script&lang=js"
export * from "./BaseFormCheckboxFieldWithValidator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports